import { render, staticRenderFns } from "./digitalize.vue?vue&type=template&id=a13e40b6&scoped=true&"
import script from "./digitalize.vue?vue&type=script&lang=js&"
export * from "./digitalize.vue?vue&type=script&lang=js&"
import style0 from "./digitalize.vue?vue&type=style&index=0&id=a13e40b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13e40b6",
  null
  
)

export default component.exports